<template>
  <b-card :class="'main'">
    <h1>
      {{
        $t(
          comOnly
            ? 'pages.how_it_works_ComOnly.title'
            : 'pages.how_it_works.title',
        )
      }}
    </h1>
    <span
      v-html="
        $t(
          comOnly
            ? 'pages.how_it_works_ComOnly.body'
            : 'pages.how_it_works.body',
        )
      "
    ></span>
  </b-card>
</template>
<script>
export default {
  computed: {
    comOnly() {
      return this.$route.params['com_only'];
    },
  },
};
</script>
